import { Type } from 'class-transformer';
import type dayjs from 'dayjs';
import { LinkedIntegration } from './linked_integration';
import { Model } from './model';
import { ObjectSchema } from './object_schema';
import { TransformStringToDayJS } from './utils';

export enum ModelSyncStatus {
  PARTIAL = 'partial',

  SYNCING = 'syncing',

  SYNCED = 'synced',

  FAILED = 'failed',
}

export class ChildUnifiedModelMixin extends Model {
  @TransformStringToDayJS()
  remote_created_at: dayjs.Dayjs | null;

  @TransformStringToDayJS()
  remote_modified_at: dayjs.Dayjs | null;
}

export class UnifiedModelMixin extends ChildUnifiedModelMixin {
  @TransformStringToDayJS()
  last_synced_at: dayjs.Dayjs | null;

  @Type(() => LinkedIntegration)
  linked_integration: LinkedIntegration;

  sync_status: ModelSyncStatus;
}

export class UnifiedModel extends ObjectSchema {
  has_endpoints: boolean;
}
